import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import workSpaceCss from "../../css/workSpaceOverView.module.css";
import PopulateFSSideMenu from "../../components/consol/PopulateFSSideMenu";
import PopulateFSTopBar from "../../components/consol/PopulateFSTopBar";

import swal from "sweetalert";
import {
  deletePopulateFSApiHandler,
  getConsolPopulateFSDetailsApiHandler,
  updatePopulateFSApiHandler,
  getConsolMappingDetailsApiHandler,
  rearrangeCashflowRow,
  addConsolCashflowRow,
  replaceConsolCashflowTableApiHandler,
  replaceConsolDisclosureTableApiHandler,
  addConsolNotesSubgroupApiHandler,
  deleteConsolNotesSubgroupApiHandler,
  addConsolFSSectionApiHandler,
  updateConsolFSSectionApiHandler,
  deleteConsolFSSectionApiHandler,
  rearrangeConsolFSSectionApiHandler,
} from "../../../WorkSpace/Components/ApiServices/apiHandler";
import { motion } from "framer-motion";
import commoncss from "../../css/common.module.css";
import bookclosurecss from "../../css/bookclosure.module.css";
import CashflowWorkings from "../libraries/CashflowWorkings";
import SidePanel from "../libraries/SidePanel";
import AddNewAdjustment from "../standalone_fs/AddNewAdjustment";
import AdjustmentLog from "../standalone_fs/AdjustmentLog";
import QuillReactEditor from "../../components/QuillReactEditor";
import ConsolFSTable from "./ConsolFSTable";
import ConsolFSBottomAddSection from "./ConsolFSBottomAddSection";
import TemplateTableGenerator from "../libraries/TemplateTableGenerator";
import sidemenucss from "../../css/sidemenu.module.css";
import { Spinner } from "react-bootstrap";
import DeletePopup from "../../elements/DeletePopup";
import { ReactComponent as DelIcon } from "../../assets/icons/delete_red.svg";
import { ReactComponent as EditIcon } from "../../assets/icons/editPri.svg";
import MenuIcon from "../../assets/icons/Menu.png";

const FS_CATS_WITHOUT_ROW_AND_BOTTOM_UI = [
  "BS",
  "PL",
  "BS notes",
  "PL notes",
  "Adjustments",
];
const ConsolFS = () => {
   const {consolID} = useParams();
   const location = useLocation();

   const workspace_data = useSelector((state) => state.WSReducer);
   const workspaceName = workspace_data?.response?.[0]?.workspace_name || sessionStorage.getItem("adj_workspace_name") || localStorage.getItem("workspaceName") || "Workspace";
   const initialWorkspaceID = workspace_data?.response?.[0]?._id || localStorage.getItem("ws_id") || "";
   const [workspaceID, setWorkspaceID] = useState(initialWorkspaceID);

   const [consolName, setConsolName] = useState(
     location.state?.consolName || sessionStorage.getItem("adj_consol_name") || "Consol"
   );

   useEffect(() => {
     if (location.state?.consolName) {
       setConsolName(location.state.consolName);
       sessionStorage.setItem("adj_consol_name", location.state.consolName);
     }
   }, [location.state?.consolName]);

   useEffect(() => {
     if (workspace_data?.response?.[0]?.workspace_name) {
       sessionStorage.setItem("adj_workspace_name", workspace_data.response[0].workspace_name);
     }
     if (workspace_data?.response?.[0]?._id) {
       setWorkspaceID(workspace_data.response[0]._id);
     }
   }, [workspace_data]);

   useEffect(() => {
     if (consolID) {
       getConsolMappingDetailsApiHandler({ consolID })
         .then((res) => {
           if (res?.data?.success) {
             const data = res.data;
             const fetchedWsId = data.workspaceID || data.workspace_id || data.data?.workspaceID || data.data?.workspace_id;
             if (fetchedWsId) {
               setWorkspaceID(fetchedWsId);
               localStorage.setItem("ws_id", fetchedWsId);
             }
           }
         })
         .catch((err) => console.log("Error loading workspace ID:", err));
     }
   }, [consolID]);

   const subTitle = consolName;

  //const consolID = "6953a4b5d73b643b49e70826";

  const history = useHistory();
  const dispatch = useDispatch();

  const [activeCat, setActiveCat] = useState(() => {
    let isReload = false;
    try {
      const navigationEntries = performance.getEntriesByType("navigation");
      if (navigationEntries.length > 0) {
        isReload = navigationEntries[0].type === "reload";
      } else if (window.performance && window.performance.navigation) {
        isReload = window.performance.navigation.type === 1;
      }
    } catch (e) {
      console.warn("Performance API navigation type check failed:", e);
    }

    if (isReload) {
      return sessionStorage.getItem(`consol_populate_active_cat_${consolID}`) || "BS";
    }
    return "BS";
  });

  useEffect(() => {
    if (consolID) {
      sessionStorage.setItem(`consol_populate_active_cat_${consolID}`, activeCat);
    }
  }, [activeCat, consolID]);

  const [isNotes, setIsNotes] = useState(false);
  const [loadData, setLoadData] = useState([]);
  const [notesId, setNotesId] = useState(null);
  const [redirectNote, setRedirectNote] = useState(null);

  const [showCashflowWorkings, setShowCashflowWorkings] = useState(
    localStorage.getItem("consol_showCashflowWorkings") === "true"
  );
  const [showAdjustmentLog, setShowAdjustmentLog] = useState(false);
  const [showAddAdjustment, setShowAddAdjustment] = useState(false);

  useEffect(() => {
    localStorage.setItem("consol_showCashflowWorkings", showCashflowWorkings ? "true" : "false");
  }, [showCashflowWorkings]);
  const [subMenuId, setSubMenuId] = useState(null);
  const [subgroupId, setSubGroupId] = useState(null);
  const [targetSubGroupId, setTargetSubGroupId] = useState(null);
  const [columns, setColumns] = useState([]);
  const [subMenu, setSubMenu] = useState(null);
  const [rows, setRows] = useState([]);
  const [notesData, setNotesData] = useState(null);
  const [updateTrigger, setUpdateTrigger] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [redirectSearch, setRedirectSearch] = useState(null);
  const categoryRef = useRef(activeCat);
  const [fsNotesResponseData, setFsNotesResponseData] = useState(null);

  const [bottomBlocks, setBottomBlocks] = useState([]);
  const [isAddingTable, setIsAddingTable] = useState(false);
  const [forceOpenTableId, setForceOpenTableId] = useState(null);
  const [deleteEditorConfirm, setDeleteEditorConfirm] = useState({ isOpen: false, subgroupId: null });

  const [showLinkPanel, setShowLinkPanel] = useState(false);
  const [activeCellKey, setActiveCellKey] = useState(null);
  const [selectedCell, setSelectedCell] = useState(null);
  const [panelDataID, setPanelDataID] = useState(null);

  const genId = () => Math.random().toString(36).slice(2);

  const handleCellLinkClick = (row, col, tableID, isLinked) => {
    const normalize = (v) => String(v || "").trim().toLowerCase();
    
    let rowIdentifier = row.Particulars || row.particular || row.particulars || row.name || row.description;
    
    if (!rowIdentifier) {
      for (const key of Object.keys(row)) {
        if (key !== '_id' && key !== 'id' && key !== 'rowId' && (typeof row[key] === 'string' || typeof row[key] === 'number') && row[key] !== "") {
          rowIdentifier = row[key];
          break;
        }
      }
    }
    const rowName = normalize(rowIdentifier);
    const colName = col.field || col;
    const currentRowId = row.rowId || row._id || row.id || tableID;
    const finalRowName = String(rowIdentifier || currentRowId || "");
    
    const key = `${subMenuId || ''}-${currentRowId || ''}-${rowName}-${colName}`;
    
    setSelectedCell({ row: finalRowName, rowId: currentRowId, col: colName, tableId: tableID, sectionId: subMenuId });
    setPanelDataID(activeCat === "disclosure" ? tableID : currentRowId);
    setActiveCellKey(key);
    setShowLinkPanel(true);
  };

  const allowTableRowAdd =
    !FS_CATS_WITHOUT_ROW_AND_BOTTOM_UI.includes(activeCat) &&
    activeCat !== "checklist";
  const showBottomAddControls = allowTableRowAdd;

  const handleAddParagraph = async () => {
    if (activeCat === "disclosure") {
      try {
        const activeGroupId = subMenuId || fsNotesResponseData?.[0]?._id;
        if (!activeGroupId) {
          swal("Error", "No group ID found. Please select a note.", "error");
          return;
        }

        const params = {
          consolID: consolID,
          category: "disclosure",
          groupID: activeGroupId,
        };

        const payload = {
          dataType: "text",
          textRaw: "<p></p>",
          textPlain: "",
        };

        const response = await addConsolNotesSubgroupApiHandler(params, payload);
        if (response?.data?.success) {
          await getPopulateFS("disclosure");
        } else {
          swal("Error", response?.data?.error || "Unable to create editor", "error");
        }
      } catch (err) {
        console.error("handleAddParagraph error:", err);
        swal("Error", err?.response?.data?.error || "Unable to create editor", "error");
      }
      return;
    }

    setBottomBlocks((prev) => [
      ...prev,
      { id: genId(), type: "text", text: [{ content: "" }] },
    ]);
  };

  const handleAddTable = () => {
    setIsAddingTable(true);
  };

  const removeItem = (id) => {
    setBottomBlocks((prev) => prev.filter((b) => b.id !== id));
  };

  const updateEditorContent = (id, newContent) => {
    setBottomBlocks((prev) =>
      prev.map((b) =>
        b.id === id ? { ...b, text: [{ content: newContent }] } : b
      )
    );
  };

  const updateTableItem = (id, patch) => {
    setBottomBlocks((prev) =>
      prev.map((b) => (b.id === id ? { ...b, ...patch } : b))
    );
  };

  const onNewTableBlock = async (next) => {
    if (activeCat === "disclosure") {
      try {
        const activeGroupId = subMenuId || fsNotesResponseData?.[0]?._id;
        if (!activeGroupId) {
          swal("Error", "No group ID found. Please select a note.", "error");
          return;
        }

        const tableColumnData = (next.tableColumn || []).map((col) => ({
          name: col.name || "",
        }));

        const finalTableColumn =
          tableColumnData.length > 0
            ? tableColumnData
            : [
                { name: "Particulars" },
                { name: "Current Year" },
                { name: "Previous Year" },
              ];

        const defaultTableRows =
          (next.tableData && next.tableData.length > 0)
            ? next.tableData
            : (next.table && next.table.length > 0)
            ? next.table
            : [
                {
                  particular: "Guarantees given",
                  lineType: "line item",
                  currentYear: 0,
                  previousYear: 0,
                },
              ];

        const params = {
          consolID: consolID,
          category: "disclosure",
          groupID: activeGroupId,
        };

        const payload = {
          dataType: "table",
          tableTitle: next.tableTitle || "Contingent liabilities",
          tableType: "default",
          tableColumn: finalTableColumn,
          table: defaultTableRows,
        };

        const response = await addConsolNotesSubgroupApiHandler(params, payload);
        if (response?.data?.success) {
          setIsAddingTable(false);
          await getPopulateFS("disclosure");
        } else {
          swal("Error", response?.data?.error || "Unable to create table", "error");
        }
      } catch (err) {
        console.error("onNewTableBlock error:", err);
        swal("Error", err?.response?.data?.error || "Unable to create table", "error");
      }
      return;
    }

    const id = genId();
    setBottomBlocks((prev) => [
      ...prev,
      {
        id,
        type: "table",
        tableTitle: next.tableTitle,
        tableRow: next.tableRow,
        tableColumn: next.tableColumn,
        hasCellData: next.hasCellData,
        tableData: next.tableData,
        tableType: "",
        table: [],
      },
    ]);
  };

  const onDragEndItems = (result) => {
    if (!result.destination) return;
    const items = Array.from(bottomBlocks);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setBottomBlocks(items);
  };

  useEffect(() => {
    if ((activeCat === "BS") || (activeCat === "PL")) {
      const result = transformData(loadData ?? []);
      setRows(result ?? []);
    } else {

      setRows(loadData ?? []);
    }
  }, [loadData]);


  useEffect(() => {
    setColumns([]);

    // BS / PL
    if (activeCat === "BS" || activeCat === "PL") {
      setIsNotes(false);
      setSubMenu(null);
      setColumns([
        {
          label: "Particular",
          field: "particular",
          align: "left",
          editable: false,
          width: "70%",        
          cellStyle: () => ({
            whiteSpace: "normal", 
            wordBreak: "break-word",
            lineHeight: "1.4",
          }),
          headerStyle: {
            width: 700, 
            minWidth: 700,        
            whiteSpace: "normal",
          },
        },
        {
          label: "Notes",
          field: "notes",
          align: "center",
          editable: false,
          type: "redirect",
          width: 100,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          label: "Current Year",
          field: "currentYear",
          align: "right",
          editable: false,
          type: "number",
          width: 160,
          minWidth: 160,
          maxWidth: 160,

        },
        {
          label: "Previous Year",
          field: "previousYear",
          align: "right",
          editable: false,
          type: "number",
          width: 180,
          minWidth: 180,
          maxWidth: 180,

        },
        // {
        //   label: "References",
        //   field: "references",
        //   align: "left",
        //   editable: false,
        //   type: "array",
        // },
      ]);
      return;
    }

    // SOCIE / Cashflow / Disclosure
    if (["socie", "cashflow"].includes(activeCat)) {
      setIsNotes(false);
      setSubMenu(null);

      if (rows.length > 0) {
        let catRows = Array.from(
          new Set(
            rows.flatMap((r) => (r && typeof r === "object" ? Object.keys(r) : []))
          )
        );

        if (activeCat === "cashflow") {
          if (!catRows.some((k) => k.toLowerCase() === "currentyear")) catRows.push("currentYear");
          if (!catRows.some((k) => k.toLowerCase() === "previousyear")) catRows.push("previousYear");
        }
        
        // Reorder: Put Years at the end
        const sortedRows = [
          ...catRows.filter(c => {
             const lower = String(c).toLowerCase().trim();
             return !["_id", "linetype", "line type", "line-type", "references", "companies", "company", "currentyear", "previousyear", "basecurrentyear", "basepreviousyear", "groupingid", "grouping id", "formula", "formulatype", "isbold", "is_bold", "formula_type"].includes(lower);
          }),
          ...catRows.filter(c => ["currentyear", "previousyear", "basecurrentyear", "basepreviousyear"].includes(c.toLowerCase())).sort((a,b) => {
             // currentYear before previousYear
             if (a.toLowerCase().includes("current") && b.toLowerCase().includes("previous")) return -1;
             if (a.toLowerCase().includes("previous") && b.toLowerCase().includes("current")) return 1;
             return 0;
          })
        ];

        const tableCols = sortedRows
          .filter(
            (item) => {
              const lower = String(item).toLowerCase().trim();
              if (["_id", "linetype", "line type", "references", "formulatype", "isbold", "is_bold", "formula_type"].includes(lower)) {
                return false;
              }
              if (activeCat === "cashflow" && (lower === "basecurrentyear" || lower === "basepreviousyear")) {
                return false;
              }
              return true;
            }
          )
          .map((item) => {
            const lowerItem = item.toLowerCase();
            const isText =
              lowerItem.includes("particular") ||
              lowerItem.includes("name");

            const isSocie = activeCat === "socie";

            const colWidth = isText
              ? (isSocie ? 520 : "70%")
              : (isSocie ? 320 : 160);
            return {
              label: lowerItem === "currentyear" ? "Current Year" : lowerItem === "previousyear" ? "Previous Year" : item,
              field: item,
              width: colWidth,
              minWidth: isSocie
                ? (isText ? 520 : 320)
                : typeof colWidth === "number"
                ? colWidth
                : 160,
              align: !isText ? "right" : "left",
              editable: false,
              type: isSocie ? "custom" : "text",
            };
          });

        setColumns(tableCols);
      }
      return;
    }

    // Notes categories
    if (
      ["general notes", "BS notes", "PL notes","disclosure", "checklist"].includes(activeCat)
    ) {
      setIsNotes(true);
      const submenuArray = rows.map((item) => ({
        label: item.particular,
        value: item._id,
        subGroup: item.subgroup, 
      }));
      setSubMenu({
        category: activeCat,
        submenu: submenuArray,
      });
      setColumns([]);
      return;
    }

    // Default
    setIsNotes(false);
    setSubMenu(null);
    setColumns([]);
  }, [activeCat, rows]);

  useEffect(() => {
    if (!isNotes) return;
    if (!subMenu?.submenu?.length) return;

    // If we are redirecting, wait for the redirect sync to handle subMenuId
    if (subMenuId || redirectNote) return;

    const first = subMenu.submenu[0];
    setSubMenuId(first.value);
  }, [isNotes, activeCat, subMenu, subMenuId, redirectNote]);

  const applyTableRowsUpdate = (updatedRows, subgroupID) => {
    if (!subgroupID) {
      setRows(updatedRows);
      return;
    }

    setNotesData((prev) => {
      if (!prev) return prev;
      const subgroups = prev.subgroup || prev.subGroup || [];
      return {
        ...prev,
        subgroup: subgroups.map((sg) =>
          sg._id === subgroupID ? { ...sg, table: updatedRows } : sg
        ),
      };
    });

    setRows((prev) =>
      prev.map((group) => {
        if (group._id !== subMenuId) return group;
        return {
          ...group,
          subgroup: (group.subgroup || group.subGroup || []).map((sg) =>
            sg._id === subgroupID ? { ...sg, table: updatedRows } : sg
          ),
        };
      })
    );

    setFsNotesResponseData((prev) =>
      (prev || []).map((group) => {
        if (group._id !== subMenuId) return group;
        return {
          ...group,
          subgroup: (group.subgroup || group.subGroup || []).map((sg) =>
            sg._id === subgroupID ? { ...sg, table: updatedRows } : sg
          ),
        };
      })
    );
  };

  const isRowBold = (r) => {
    if (!r) return false;
    const b = r.isBold !== undefined ? r.isBold : r.isbold;
    if (typeof b === "boolean") return b;
    if (typeof b === "number") return b === 1;
    if (typeof b === "string") return b.toLowerCase() === "true" || b === "1";
    return false;
  };

  const handleRowsChange = (updatedRows, subgroupID, fromIndex, toIndex) => {
    if (activeCat === "disclosure") {
      applyTableRowsUpdate(updatedRows, subgroupID);
      const params = {
        consolID: consolID,
        category: "disclosure",
        groupID: subMenuId || fsNotesResponseData?.[0]?._id,
        subgroupID: subgroupID,
      };
      const hasRealParticular = updatedRows.some(
        (r) => r.particular && String(r.particular).trim() !== ""
      );

      const cleanRows = updatedRows
        .filter((r) => !r.isNewRow)
        .map(({ isNewRow, ...rest }) => {
          const rowObj = {};
          Object.keys(rest).forEach((key) => {
            if (key === "_id" && String(rest._id).startsWith("temp_")) return;
            if (key === "particular" && !hasRealParticular && (!rest.particular || String(rest.particular).trim() === "")) return;

            let val = rest[key];
            const keyLower = key.toLowerCase();

            if (
              keyLower.includes("currentyear") ||
              keyLower.includes("previousyear") ||
              keyLower.includes("basecurrentyear") ||
              keyLower.includes("basepreviousyear") ||
              keyLower.includes("current_year") ||
              keyLower.includes("previous_year")
            ) {
              if (val === null || val === undefined || String(val).trim() === "") {
                rowObj[key] = 0;
              } else if (typeof val === "number") {
                rowObj[key] = isNaN(val) ? 0 : val;
              } else {
                const cleaned = String(val)
                  .replace(/,/g, "")
                  .replace(/\(/g, "-")
                  .replace(/\)/g, "")
                  .trim();
                const num = Number(cleaned);
                rowObj[key] = isNaN(num) ? 0 : num;
              }
              return;
            }

            if (typeof val === "string" && val.includes(",")) {
              const cleaned = val
                .replace(/,/g, "")
                .replace(/\(/g, "-")
                .replace(/\)/g, "")
                .trim();
              if (
                cleaned !== "" &&
                !isNaN(Number(cleaned)) &&
                !keyLower.includes("particular") &&
                !keyLower.includes("reason") &&
                !keyLower.includes("name") &&
                !keyLower.includes("text") &&
                !keyLower.includes("ref")
              ) {
                val = Number(cleaned);
              }
            }

            rowObj[key] = val;
          });
          return rowObj;
        });
      const payload = {
        table: cleanRows,
      };
      replaceConsolDisclosureTableApiHandler(params, payload)
        .then(() => {
          console.log("Disclosure table saved successfully");
          getPopulateFS(activeCat);
        })
        .catch((err) => {
          swal(
            "Error",
            err?.response?.data?.error || "Unable to save disclosure table",
            "error"
          );
        });
      return;
    }

    if (!isNotes || !subgroupID) {
      setRows(updatedRows);
      if (activeCat === "cashflow") {
        const saveFullCashflowTable = () => {
          const params = { consolID: consolID, category: "cashflow" };
          const payload = {
            table: updatedRows.map((r) => {
              const rowObj = {
                particular: r.particular || "",
                lineType: r.lineType || "line item",
                formulaType: r.formulaType || null,
                isBold: r.isBold || false,
                cashflowRow: r.cashflowRow || null,
                cashflowSection: r.cashflowSection || null,
              };
              if (r._id && !String(r._id).startsWith("temp_")) {
                rowObj._id = r._id;
              }
              return rowObj;
            })
          };
          replaceConsolCashflowTableApiHandler(params, payload)
            .then(() => {
               console.log("Cashflow table updated");
               getPopulateFS(activeCat);
            })
            .catch((err) => swal("Error", err?.response?.data?.error || "Unable to save cashflow row", "error"));
        };

        if (fromIndex !== undefined && toIndex !== undefined && fromIndex >= 0 && toIndex >= 0 && fromIndex !== toIndex) {
          rearrangeCashflowRow(consolID, { fromIndex, toIndex })
            .then(() => console.log("Rearranged cashflow row"))
            .catch((err) => {
              console.warn("Error rearranging cashflow row, falling back to full replace:", err);
              saveFullCashflowTable();
            });
        } else {
          saveFullCashflowTable();
        }
      }
      return;
    }

    applyTableRowsUpdate(updatedRows, subgroupID);

    const params = {
      category: activeCat,
      consolID: consolID,
      groupID: subMenuId,
      subgroupID,
    };
    const payload = { table: updatedRows };

    updatePopulateFSApiHandler(params, payload).catch((error) => {
      swal(
        "Error",
        error?.response?.data?.error || "Unable to save row order",
        "error"
      );
    });
  };

  const handleCashflowRowAdd = (position, row) => {
    const payload = {
      particular: row?.particular ?? "New cashflow line",
      lineType: "line item",
      position: typeof position === "number" ? position : null,
      formulaType: null,
      isBold: false,
    };
    addConsolCashflowRow(consolID, payload)
      .then(() => {
         console.log("Cashflow row added");
         getPopulateFS("cashflow");
      })
      .catch((err) => console.error("addCashflowRow error", err));
  };


  const menuItems = [
    { label: "Balance Sheet", value: "BS" },
    { label: "P&L Statement", value: "PL" },
    { label: "General Notes", value: "general notes" },
    { label: "Cashflow", value: "cashflow" },
    { label: "SOCIE", value: "socie" },
    { label: "Balance Sheet Notes", value: "BS notes" },
    { label: "P&L Statement Notes", value: "PL notes" },
    { label: "Disclosures", value: "disclosure" },
    // { label: "Disclosures Checklist", value: "checklist" },
  ];

  const getPopulateFS = (cat) => {
    const getParams = {
      category: cat,
      consolID: consolID,
    };
    return getConsolPopulateFSDetailsApiHandler(getParams)
      .then((response) => {
        // RACE CONDITION CHECK
        if (categoryRef.current !== cat) return;

        console.log("response", response);

        if (response?.data?.success === true) {
          const catData = response?.data?.data;
          setLoadData(catData);
          // For notes categories, also store as fsNotesResponseData for redirect search
          if (
            ["BS notes", "PL notes", "general notes", "disclosure", "checklist"].includes(cat)
          ) {
            setFsNotesResponseData(catData);
          }
        }
        else {
          setLoadData([]);
          swal(
            "Error",
            response?.data?.error || "Unable to get FS the data",
            "error"
          );
        }
      })
      .catch((error) => {
        if (categoryRef.current !== cat) return;
        setLoadData([]);
        swal(
          "Error",
          error?.response?.data?.error || "Unable to Populate FS the data",
          "error"
        );
      })
      .finally(() => {
        if (categoryRef.current === cat) {
          setIsLoading(false);
        }
      });
  };

  // When category changes, reset and fetch
  useEffect(() => {
    categoryRef.current = activeCat;
    setIsLoading(true);
    setLoadData([]);
    setRows([]);
    setColumns([]);
    setSubMenu(null);
    setIsNotes(false);
    setNotesData(null);
    setSubGroupId(null);
    setFsNotesResponseData(null);
    // Don't clear subMenuId if we are in the middle of a redirect
    if (!redirectSearch) {
      setSubMenuId(null);
    }
    getPopulateFS(activeCat);
  }, [activeCat, showCashflowWorkings]);

  const debounceTimer = useRef(null);

  const handleTableEdit = ({ _id, key, value, type = "table", tableId }) => {
    if (type !== "text" && (activeCat === "cashflow" || activeCat === "disclosure")) return;

    const params = {
      category: activeCat,
      consolID: consolID,
    };

    if (isNotes && type !== "text") {
      params["groupID"] = subMenuId;
      if (activeCat === "checklist") {
        params["subgroupID"] = _id;
      } else {
        params["subgroupID"] = tableId;
        params["rowID"] = _id;
      }
    } else {
      if (
        activeCat === "BS" ||
        activeCat === "PL" ||
        activeCat === "socie" ||
        activeCat === "cashflow"
      ) {
        params["groupID"] = _id;
      }
    }

    const payload = {};

    if (isNotes && type === "text") {
      params["groupID"] = subMenuId;
      params["subgroupID"] = _id;

      payload["dataType"] = "text";
      payload["textRaw"] = key; // html
      payload["textPlain"] = value; // plaintext
    } else {
      if (isNotes) {
        payload["dataType"] = "table";
      }
      payload[key] = value;
    }

    console.log("update params,payload", params, payload);

    updatePopulateFSApiHandler(params, payload)
      .then((response) => {
        if (response?.data?.success === true) {
          if (isNotes) {
            if (type === "text") {
              // Update text subgroup in rows
              setRows((prev) =>
                prev.map((group) => {
                  if (group._id !== subMenuId) return group;
                  return {
                    ...group,
                    subgroup: (group.subgroup || group.subGroup || []).map(
                      (sg) => {
                        if (sg._id !== _id) return sg;
                        return {
                          ...sg,
                          textRaw: payload.textRaw,
                          textPlain: payload.textPlain,
                        };
                      }
                    ),
                  };
                })
              );
            } else {
              // Update table row inside subgroup
              setRows((prev) =>
                prev.map((group) => {
                  if (group._id !== subMenuId) return group;
                  return {
                    ...group,
                    subgroup: (group.subgroup || group.subGroup || []).map(
                      (sg) => {
                        if (sg._id !== subgroupId) return sg;
                        return {
                          ...sg,
                          table: (sg.table || []).map((row) =>
                            row._id === _id ? { ...row, [key]: value } : row
                          ),
                        };
                      }
                    ),
                  };
                })
              );
            }
          } else {
            // Non-notes tables (BS, PL, etc.)
            setRows((prev) =>
              prev.map((row) =>
                row._id === _id ? { ...row, [key]: value } : row
              )
            );
          }
        } else {
          swal(
            "Error",
            response?.data?.error || "Unable to update the data",
            "error"
          );
        }
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable to save the data",
          "error"
        );
      });
  };

  const handleTableEditDebounced = (args) => {
    clearTimeout(debounceTimer.current);

    debounceTimer.current = setTimeout(() => {
      handleTableEdit(args);
    }, 2000);
  };

  const disclosureTextDebounceRef = useRef({});
  const disclosureTextContentRef = useRef({});

  const handleDisclosureTextSave = async (sgId) => {
    if (disclosureTextDebounceRef.current[sgId]) {
      clearTimeout(disclosureTextDebounceRef.current[sgId]);
    }
    const content = disclosureTextContentRef.current[sgId];
    if (!content) return;

    try {
      const activeGroupId = subMenuId || fsNotesResponseData?.[0]?._id;
      if (!activeGroupId) return;

      const params = {
        consolID: consolID,
        category: activeCat || "disclosure",
        groupID: activeGroupId,
      };

      const payload = {
        dataType: "text",
        textRaw: content.html,
        textPlain: content.text,
      };

      await addConsolNotesSubgroupApiHandler(params, payload);
    } catch (err) {
      console.error("Error saving disclosure text via addNotesSubgroup:", err);
    }
  };

  const handleDisclosureTextEditDebounced = (sgId, content) => {
    disclosureTextContentRef.current[sgId] = content;

    const updateGroupList = (list) =>
      (list || []).map((group) => {
        if (group._id !== (subMenuId || fsNotesResponseData?.[0]?._id)) return group;
        return {
          ...group,
          subgroup: (group.subgroup || group.subGroup || []).map((sg) => {
            if (sg._id !== sgId) return sg;
            return {
              ...sg,
              textRaw: content.html,
              textPlain: content.text,
            };
          }),
        };
      });

    // 1. Immediately update local state for smooth typing
    setRows(updateGroupList);
    setFsNotesResponseData(updateGroupList);

    // 2. Debounce the API call to update text subgroup
    if (disclosureTextDebounceRef.current[sgId]) {
      clearTimeout(disclosureTextDebounceRef.current[sgId]);
    }

    disclosureTextDebounceRef.current[sgId] = setTimeout(() => {
      handleDisclosureTextSave(sgId);
    }, 1500);
  };

  useEffect(() => {
    return () => {
      clearTimeout(debounceTimer.current);
      Object.values(disclosureTextDebounceRef.current).forEach((timer) =>
        clearTimeout(timer)
      );
    };
  }, []);

  const ShowDetails = () => {

  const formatIndianNumber = (val) => {
    if (val == null) return "";
    const num = Number(val);
    if (isNaN(num)) return val;

    if (num < 0) {
      return "(" + Math.abs(num).toLocaleString("en-IN") + ")";
    }
    return num.toLocaleString("en-IN");
  };

  const formattedRows =
    activeCat === "socie"
      ? rows.map((row) => {
          const newRow = { ...row };

          Object.keys(newRow).forEach((key) => {
            if (
              key !== "_id" &&
              key !== "particular" &&
              key !== "lineType" &&
              key !== "references" &&
              key !== "isBold" &&
              key !== "isbold" &&
              key !== "formulaType" &&
              key !== "groupingID" &&
              typeof newRow[key] !== "boolean" &&
              newRow[key] !== null &&
              newRow[key] !== undefined &&
              typeof newRow[key] !== "object" &&
              String(newRow[key]).trim() !== "" &&
              !isNaN(Number(newRow[key]))
            ) {
              newRow[key] = formatIndianNumber(newRow[key]);
            }
          });

          return newRow;
        })
      : rows;

  return (
    <ConsolFSTable
      columns={columns}
      rows={formattedRows}
      onRowsChange={handleRowsChange}
      onCellChangeImmediate={handleTableEditDebounced}
      redirectTo={redirectTo}
      allowDragAndAdd={allowTableRowAdd}
      activeCat={activeCat}
      onAddRow={activeCat === "cashflow" ? handleCashflowRowAdd : null}
      onToggleCashflowWorkings={() => setShowCashflowWorkings(true)}
      onCellLinkClick={handleCellLinkClick}
    />
  );
};

  const ShowChecklist = ({ subMenuId }) => {
    if (!subMenu) return null;

    const selNote = subMenu.submenu.find((item) => item.value === subMenuId);
    const rows = selNote?.subGroup || [];

    const checklistColumns = [
      {
        label: "Paragraph reference",
        field: "reference",
        align: "left",
        editable: false,
        type: "popup",
      },
      {
        label: "Disclosure",
        field: "notes",
        align: "left",
        maxWidth: 200,
        editable: false,
        type: "text",
      },
      {
        label: "Yes",
        field: "value",
        optionValue: "Y",
        align: "center",
        editable: false,
        type: "checkbox",
      },
      {
        label: "No",
        field: "value",
        optionValue: "N",
        align: "center",
        editable: false,
        type: "checkbox",
      },
      {
        label: "NA",
        field: "value",
        optionValue: "NA",
        align: "center",
        editable: false,
        type: "checkbox",
      },
      {
        label: "Remarks",
        field: "remark",
        align: "left",
        editable: false,
        type: "text",
      },
    ];

    return (
      <>
        <ConsolFSTable
          columns={checklistColumns}
          rows={rows}
          onRowsChange={handleRowsChange}
          onCellChangeImmediate={handleTableEditDebounced}
          redirectTo={redirectTo}
        />
      </>
    );
  };

  const getPopulateFSNotes = async (cat) => {
    try {
      const getParams = {
        category: cat,
        consolID: consolID,
      };

      const response = await getConsolPopulateFSDetailsApiHandler(getParams);

      if (response?.data?.success === true) {
        return response.data.data;
      }

      return [];
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  const triggerRedirectSearch = (searchPayload, sourceRows) => {
    const searchArg = String(searchPayload.arg || "").trim().toLowerCase();
    const searchPart = String(searchPayload.particular || "").trim().toLowerCase();

    const normalize = (str) => String(str || "").replace(/[^a-z0-9]/gi, "").toLowerCase();
    const normPart = normalize(searchPart);

    let foundNoteId = null;
    let foundSubGroupId = null;

    // 1. Try to find the Note Header - Exact match first
    let directMatch = sourceRows.find(item => {
      const itemName = String(item.particular || "").trim().toLowerCase();
      const itemNote = String(item.notes || "").trim().toLowerCase();
      const normItemName = normalize(itemName);

      return (
        (searchArg && itemNote === searchArg) ||
        (normPart && normItemName === normPart) ||
        (searchPart && itemName === searchPart)
      );
    });

    // Fallback to partial match if no exact match
    if (!directMatch) {
      directMatch = sourceRows.find(item => {
        const itemName = String(item.particular || "").trim().toLowerCase();
        const itemNote = String(item.notes || "").trim().toLowerCase();
        const normItemName = normalize(itemName);

        return (
          (normPart && (normItemName.includes(normPart) || normPart.includes(normItemName))) ||
          (searchArg && (itemNote.includes(searchArg) || searchArg.includes(itemNote))) ||
          (searchPart && (itemName.includes(searchPart) || searchPart.includes(itemName)))
        );
      });
    }

    if (directMatch) {
      foundNoteId = directMatch._id;
      
      // 2. Try to find the specific subgroup/table inside that note
      const sgs = (directMatch.subgroup || directMatch.subGroup || []).filter(
        (sg) => !sg.category || sg.category === searchPayload.targetCat
      );
      
      // Exact match for subgroup
      let matchingSg = sgs.find(sg => {
        const title = String(sg.tableTitle || sg.particular || "").toLowerCase();
        const normTitle = normalize(title);
        return normPart && normTitle === normPart;
      });

      // Partial match for subgroup
      if (!matchingSg) {
        matchingSg = sgs.find(sg => {
          const title = String(sg.tableTitle || sg.particular || "").toLowerCase();
          return title.includes(searchPart) || searchPart.includes(title);
        });
      }
      
      if (matchingSg) foundSubGroupId = matchingSg._id;
    } else {
      // 3. Fallback: Search across all subgroups if Note Header didn't match
      for (const item of sourceRows) {
        const sgs = (item.subgroup || item.subGroup || []).filter(
          (sg) => !sg.category || sg.category === searchPayload.targetCat
        );
        
        let foundSg = sgs.find(sg => {
          const title = String(sg.tableTitle || sg.particular || "").toLowerCase();
          const normTitle = normalize(title);
          return normPart && normTitle === normPart;
        });

        if (!foundSg) {
          foundSg = sgs.find(sg => {
            const title = String(sg.tableTitle || sg.particular || "").toLowerCase();
            return title.includes(searchPart) || searchPart.includes(title);
          });
        }

        if (foundSg) {
          foundNoteId = item._id;
          foundSubGroupId = foundSg._id;
          break;
        }
      }
    }

    if (foundNoteId) {
      setSubMenuId(foundNoteId);
      setRedirectNote(foundNoteId); // for sidebar auto-select only
      if (foundSubGroupId) {
        setTargetSubGroupId(foundSubGroupId);
        setSubGroupId(foundSubGroupId);
      }
      setRedirectSearch(null);
    } else if (activeCat === searchPayload.targetCat && sourceRows.length > 0) {
      // If we are in the target category and have rows but still no match, give up
      setRedirectSearch(null);
    }
  };

 const redirectTo = (arg, row) => {
  let targetCat = null;

  if (activeCat === "BS") {
    targetCat = "BS notes";
  } else if (activeCat === "PL") {
    targetCat = "PL notes";
  } else {
    targetCat = activeCat;
  }

  if (targetCat) {
    const searchPayload = {
      arg: arg,
      particular: row?.particular,
      targetCat: targetCat
    };
    setRedirectSearch(searchPayload);
    
    if (targetCat === activeCat) {
      triggerRedirectSearch(searchPayload, rows);
    } else {
      setActiveCat(targetCat);
    }
  }
};

  // Redirection Engine: Search and select the correct note once data is loaded
  // useEffect(() => {
  //   if (!redirectSearch || !isNotes || !rows.length) return;
  //    triggerRedirectSearch(redirectSearch, rows);
  //   const searchArg = String(redirectSearch.arg || "").trim().toLowerCase();
  //   const searchPart = String(redirectSearch.particular || "").trim().toLowerCase();

  //   let foundNoteId = null;
  //   let foundSubGroupId = null;

  //   // 1. Try to find match in Note Headers
  //   const directMatch = rows.find(item => {
  //     const itemNote = String(item.notes || "").trim().toLowerCase();
  //     const itemName = String(item.particular || "").trim().toLowerCase();
      
  //     return (
  //       (searchArg && (itemNote === searchArg || itemNote.includes(searchArg))) ||
  //       (searchPart && (itemName === searchPart || itemName.includes(searchPart)))
  //     );
  //   });

  //   if (directMatch) {
  //     foundNoteId = directMatch._id;
      
  //     // Try to find subgroup
  //     if (searchPart) {
  //       const sgs = directMatch.subgroup || directMatch.subGroup || [];
  //       const matchingSg = sgs.find(sg => {
  //         const title = String(sg.tableTitle || sg.particular || "").toLowerCase();
  //         return title.includes(searchPart) || searchPart.includes(title);
  //       });
  //       if (matchingSg) foundSubGroupId = matchingSg._id;
  //     }
  //   } else {
  //     // 2. Deep search in subgroups
  //     for (const item of rows) {
  //       const sgs = item.subgroup || item.subGroup || [];
  //       const foundSg = sgs.find(sg => {
  //         const title = String(sg.tableTitle || sg.particular || "").toLowerCase();
  //         return title.includes(searchPart) || searchPart.includes(title);
  //       });
  //       if (foundSg) {
  //         foundNoteId = item._id;
  //         foundSubGroupId = foundSg._id;
  //         break;
  //       }
  //     }
  //   }

  //   if (foundNoteId) {
  //     setSubMenuId(foundNoteId);
  //     if (foundSubGroupId) {
  //       setTargetSubGroupId(foundSubGroupId);
  //       setSubGroupId(foundSubGroupId);
  //     }
  //   }

  //   // Always clear search after attempt
  //   setRedirectSearch(null);
  // }, [redirectSearch, isNotes, rows]);

  useEffect(() => {
    if (!redirectSearch || activeCat !== redirectSearch.targetCat || !isNotes) return;
    // Use fsNotesResponseData if available (more reliable than rows)
    const source = fsNotesResponseData && fsNotesResponseData.length > 0
      ? fsNotesResponseData
      : rows;
    if (!source || source.length === 0) return;
    triggerRedirectSearch(redirectSearch, source);
  }, [redirectSearch, isNotes, fsNotesResponseData, rows, activeCat]);

 useEffect(() => {
  if (targetSubGroupId && isNotes) {
    const timer = setTimeout(() => {
      // Try to scroll to specific row first
      const normalize = (str) => String(str || "").replace(/[^a-z0-9]/gi, "").toLowerCase();
      const rowId = redirectSearch?.particular ? normalize(redirectSearch.particular) : null;
      
      const rowElement = rowId ? document.getElementById(rowId) : null;
      const tableElement = document.getElementById(targetSubGroupId);
      
      const element = rowElement || tableElement;

      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
    
        element.classList.add(commoncss.noteSectionHighlight);
        setTimeout(() => element.classList.remove(commoncss.noteSectionHighlight), 2000);
        setTargetSubGroupId(null);
      }
    }, 600);
    return () => clearTimeout(timer);
  }
}, [targetSubGroupId, isNotes, subMenuId]);

  useEffect(() => {
    if (!isNotes || activeCat === "checklist" || !subMenuId) {
      setNotesData(null);
      return;
    }
    const selNote = rows.find((item) => item._id === subMenuId) || null;
    setNotesData(selNote);
  }, [isNotes, activeCat, subMenuId, rows]);

  useEffect(() => {
    if (!isNotes || activeCat === "checklist" || !notesData) return;

    const subGroups = (notesData.subgroup || notesData.subGroup || []).filter(
      (sg) => !sg.category || sg.category === activeCat
    );
    const firstTableSg = subGroups.find(
      (sg) => (sg?.dataType ?? sg?.datatype) === "table"
    );

    setSubGroupId(firstTableSg?._id ?? null);
  }, [isNotes, activeCat, notesData]);

  const showNotesDetails = (noteId) => {
    setSubMenuId(noteId);
  };

  const deletePopulateFS = async (subgroupID) => {
    try {
      const activeGroupId = subMenuId || notesData?._id || fsNotesResponseData?.[0]?._id;
      const getParams = {
        category: activeCat,
        consolID: consolID,
        groupID: activeGroupId,
        subgroupID: subgroupID
      };

      let response;
      if (activeCat === "disclosure") {
        response = await deleteConsolNotesSubgroupApiHandler(getParams);
      } else {
        response = await deletePopulateFSApiHandler(getParams);
      }

      console.log("response", response);
      if (response?.data?.success || response?.status === 200) {
        setUpdateTrigger((prev) => prev + 1);
        const delEl = document.getElementById(subgroupID);
        if (delEl) delEl.style.display = "none";
        await getPopulateFS(activeCat);
        return response?.data || [];
      } else {
        swal("Error", response?.data?.error || response?.data?.message || "Unable to delete", "error");
        return [];
      }
    } catch (error) {
      console.error(error);
      swal("Error", error?.response?.data?.error || error?.response?.data?.message || "Unable to delete", "error");
      return [];
    }
  };

  const handleDeleteSubGroup = async (category, groupID) => {
    try {
      const response = await deleteConsolFSSectionApiHandler(
        { consolID: consolID, category: category, groupID: groupID },
        { deletedItemID: [groupID] }
      );
      if (response?.data?.success || response?.status === 200) {
        setUpdateTrigger((prev) => prev + 1);
        await getPopulateFS(category);
        if (subMenuId === groupID) {
          setSubMenuId(null);
        }
        return true;
      }
      return false;
    } catch (error) {
      console.error(error);
      swal("Error", error?.response?.data?.error || "Unable to delete section", "error");
      return false;
    }
  };

  const handleReorderSubGroup = async (category, fromIndex, toIndex) => {
    if (fromIndex === toIndex || fromIndex < 0 || toIndex < 0) return true;

    const previousRows = [...(rows || [])];
    const reorderedRows = [...previousRows];
    const [moved] = reorderedRows.splice(fromIndex, 1);
    reorderedRows.splice(toIndex, 0, moved);

    setRows(reorderedRows);
    setFsNotesResponseData(reorderedRows);

    try {
      const response = await rearrangeConsolFSSectionApiHandler(
        { consolID: consolID, category: category },
        { fromIndex, toIndex }
      );

      if (response?.data?.success) {
        await getPopulateFS(category);
        return true;
      }

      setRows(previousRows);
      setFsNotesResponseData(previousRows);
      swal("Error", response?.data?.error || "Unable to reorder section", "error");
      return false;
    } catch (error) {
      setRows(previousRows);
      setFsNotesResponseData(previousRows);
      console.error(error);
      swal("Error", error?.response?.data?.error || "Unable to reorder section", "error");
      return false;
    }
  };

  const handleAddSubGroup = async (category, name) => {
    try {
      const response = await addConsolFSSectionApiHandler(
        { consolID: consolID, category: category },
        { name: name }
      );
      if (response?.data?.success) {
        setUpdateTrigger((prev) => prev + 1);
        await getPopulateFS(category);
        return true;
      } else if (response?.data?.error || response?.data?.message) {
        swal("Error", response.data.error || response.data.message, "error");
        return false;
      }
      return false;
    } catch (error) {
      console.error(error);
      swal("Error", error?.response?.data?.error || "name already exists", "error");
      return false;
    }
  };

  const handleEditSubGroup = async (category, groupID, name) => {
    try {
      const response = await updateConsolFSSectionApiHandler(
        { consolID: consolID, category: category, groupID: groupID },
        { name: name }
      );
      if (response?.data?.success) {
        setUpdateTrigger((prev) => prev + 1);
        await getPopulateFS(category);
        return true;
      }
      return false;
    } catch (error) {
      console.error(error);
      swal("Error", error?.response?.data?.error || "Unable to update section name", "error");
      return false;
    }
  };


  useEffect(() => {
    if (!isNotes || activeCat === "checklist" || !subMenuId) {
      setNotesData(null);
      return;
    }

    const selNote = rows.find((item) => item._id === subMenuId) || null;
    setNotesData(selNote);

  }, [updateTrigger]);

  const renderSubGroups = (notesData) => {
    const rawSubGroups = (notesData?.subgroup || notesData?.subGroup || []).filter(
      (sg) => !sg.category || sg.category === activeCat
    );

    if (isLoading) {
      return (
        <div style={{ padding: "20px", textAlign: "center", color: "#66827a" }}>
          Loading content...
        </div>
      );
    }

    const textSubgroups = rawSubGroups.filter(
      (sg) => (sg?.dataType ?? sg?.datatype) === "text"
    );
    const tableSubgroups = rawSubGroups.filter(
      (sg) => (sg?.dataType ?? sg?.datatype) !== "text"
    );

    // Keep only the single latest text editor
    const latestTextSubgroup =
      textSubgroups.length > 0 ? textSubgroups[textSubgroups.length - 1] : null;

    const subGroups = [];
    if (latestTextSubgroup) {
      subGroups.push(latestTextSubgroup);
    }
    tableSubgroups.forEach((sg) => subGroups.push(sg));

    const formatIndianNumber = (val) => {
      if (val == null) return "";
      const num = Number(val);
      if (isNaN(num)) return String(val);

      if (num < 0) {
        return "(" + (-1 * num).toLocaleString("en-IN") + ")";
      }
      return num.toLocaleString("en-IN");
    };
    return subGroups.map((sg, idx) => {
      const type = sg?.dataType ?? sg?.datatype ?? "";
      //  TABLE 
      if (type === "table") {
        const tableItems = (Array.isArray(sg.table) ? sg.table : []).map((row) => {
  const newRow = { ...row };

  Object.keys(newRow).forEach((key) => {
    if (
      key !== "_id" &&
      key !== "particular" &&
      key !== "references" &&
      key !== "isBold" &&
      key !== "isbold" &&
      key !== "lineType" &&
      key !== "formulaType" &&
      key !== "groupingID" &&
      typeof newRow[key] !== "boolean" &&
      newRow[key] !== null &&
      newRow[key] !== undefined &&
      typeof newRow[key] !== "object" &&
      String(newRow[key]).trim() !== "" &&
      !isNaN(Number(newRow[key]))
    ) {
      newRow[key] = formatIndianNumber(newRow[key]);
    }
  });

  return newRow;
});

        if (tableItems.length === 0) {
          return null;
        }

      //   const catRows = Object.keys(tableItems[0] || {});
      //   // const tableCols = catRows
      //   //   .filter((col) => col !== "_id")
      //   //   .map((col) => {
      //   //     if (col === "references") {
      //   //       return {
      //   //         label: col,
      //   //         field: col,
      //   //         align: "left",
      //   //         editable: false,
      //   //         type: "checklistref",
      //   //       };
      //   //     }
      //   //     return {
      //   //       label: col,
      //   //       field: col,
      //   //       align: "left",
      //   //       editable: false,
      //   //       type: "text",
      //   //     };
      //   //   });
      //   const normalCols = catRows.filter(
      //     (col) => col !== "_id" && col !== "references"
      //   );

      //  const isNotesYearAlign =
      //   activeCat === "BS notes" || activeCat === "PL notes";

      // const tableCols = [
      //   ...normalCols.map((col) => ({
      //     label: col,
      //     field: col,

      //     align:
      //       isNotesYearAlign &&
      //       (col.toLowerCase().includes("current") ||
      //         col.toLowerCase().includes("previous"))
      //         ? "right"
      //         : "left",

      //     editable: false,
      //     type: "text",
      //   })),


          
      //     ...(catRows.includes("references")
      //       ? [
      //           {
      //             label: "references",
      //             field: "references",
      //             align: "left",
      //             editable: false,
      //             type: "checklistref",
      //           },
      //         ]
      //       : []),
      //   ];

      const hasAnyNonEmptyParticular = tableItems.some(
        (r) => r.particular !== undefined && r.particular !== null && String(r.particular).trim() !== ""
      );

      const catRows = Array.from(
        new Set(
          tableItems.flatMap((r) => (r && typeof r === "object" ? Object.keys(r) : []))
        )
      ).filter((col) => {
        if (col.toLowerCase() === "particular" && !hasAnyNonEmptyParticular) {
          const hasOtherCols = tableItems.some((r) =>
            Object.keys(r).some((k) => k !== "_id" && k !== "lineType" && k !== "references" && k.toLowerCase() !== "particular")
          );
          if (hasOtherCols) return false;
        }
        return true;
      });

const normalCols = activeCat === "disclosure"
  ? catRows.filter(col => {
      const lowerCol = col.toLowerCase();
      return (
        lowerCol !== "_id" &&
        lowerCol !== "references" &&
        lowerCol !== "companies" &&
        lowerCol !== "company" &&
        lowerCol !== "linetype" &&
        lowerCol !== "line type" &&
        lowerCol !== "line-type" &&
        lowerCol !== "groupingid" &&
        lowerCol !== "grouping id" &&
        lowerCol !== "formula" &&
        lowerCol !== "isbold"
      );
    })
  : [
      ...catRows.filter(col => {
        const lowerCol = col.toLowerCase();
        return (
          lowerCol !== "_id" &&
          lowerCol !== "references" &&
          lowerCol !== "companies" &&
          lowerCol !== "company" &&
          lowerCol !== "linetype" &&
          lowerCol !== "line type" &&
          lowerCol !== "line-type" &&
          lowerCol !== "currentyear" &&
          lowerCol !== "previousyear" &&
          lowerCol !== "groupingid" &&
          lowerCol !== "grouping id" &&
          lowerCol !== "formula" &&
          !(activeCat === "cashflow" && (lowerCol === "formulatype" || lowerCol === "isbold"))
        );
      }),
      ...catRows.filter(col => {
        const lowerCol = col.toLowerCase();
        return lowerCol === "currentyear" || lowerCol === "previousyear";
      }).sort((a,b) => {
        // Current year should be before Previous year
        if (a.toLowerCase() === "currentyear") return -1;
        return 1;
      })
    ];
const isNotesTable =
  activeCat === "BS notes" || activeCat === "PL notes" || activeCat === "disclosure" || activeCat === "general notes";
  
const isNotesYearAlign =
  activeCat === "BS notes" || activeCat === "PL notes" || activeCat === "disclosure" || activeCat === "general notes";

const hideReferences =
  activeCat === "BS notes" || activeCat === "PL notes" || activeCat === "disclosure" || activeCat === "general notes";

 const yearWidth = 200;
 const tableCols = [
  ...normalCols.map((col) => {
    const lowerCol = col.toLowerCase();

    const nonValRows = tableItems.filter((row) => {
      const v = row[col];
      return v !== null && v !== undefined && String(v).trim() !== "";
    });

    const isPurelyNumeric =
      nonValRows.length > 0 &&
      nonValRows.every((row) => {
        const v = row[col];
        const str = String(v).trim().replace(/,/g, "").replace(/\(/g, "-").replace(/\)/g, "");
        return !isNaN(Number(str));
      });

    const isReasonForVariance =
      lowerCol.includes("reasonforvariance") ||
      lowerCol.includes("reason for variance") ||
      lowerCol.includes("reason_for_variance");

    const isNumeratorOrDenominator =
      lowerCol.includes("numerator") ||
      lowerCol.includes("denominator");

    const isTextColumn =
      isNumeratorOrDenominator ||
      isReasonForVariance ||
      lowerCol.includes("particular") ||
      lowerCol.includes("line type") ||
      lowerCol.includes("linetype") ||
      lowerCol.includes("name") ||
      lowerCol.includes("description") ||
      lowerCol.includes("nature") ||
      lowerCol.includes("remarks") ||
      lowerCol.includes("category") ||
      (isNotesTable && !isPurelyNumeric && !lowerCol.includes("currentyear") && !lowerCol.includes("previousyear"));

    const isDateColumn =
      lowerCol === "date" ||
      lowerCol.includes("dateofvaluation") ||
      lowerCol.includes("date of valuation") ||
      lowerCol.includes("valuationdate") ||
      lowerCol.includes("valuation date") ||
      lowerCol.includes("date");

    const isMonthColumn = lowerCol.includes("month") || lowerCol.includes("months");

    const isDisclosure = activeCat === "disclosure";

    let align = "left";
    if (isDateColumn || isMonthColumn) {
      align = "center";
    } else if (isNumeratorOrDenominator) {
      align = "left";
    } else if (isReasonForVariance || lowerCol.includes("currentyear") || lowerCol.includes("previousyear")) {
      align = "right";
    } else if (isNotesTable) {
      align = isPurelyNumeric ? "right" : "left";
    } else {
      align = "left";
    }

    const isParticular = lowerCol.includes("particular") || lowerCol.includes("name") || lowerCol === "particulars";

    let displayLabel = col;
    if (lowerCol === "particular" || lowerCol === "particulars") displayLabel = "Particulars";
    else if (lowerCol === "currentyear") displayLabel = "Current Year";
    else if (lowerCol === "previousyear") displayLabel = "Previous Year";
    else if (lowerCol.startsWith("column_")) {
      displayLabel = `Column ${parseInt(col.replace(/column_/i, ""), 10) + 1}`;
    }

    return {
      label: displayLabel,
      field: col,
      width: isDateColumn
        ? 120
        : isParticular
        ? "40%"
        : isTextColumn
        ? 240
        : (lowerCol.includes("currentyear") || lowerCol.includes("previousyear") ? "auto" : 180),
      minWidth: isDateColumn
        ? 100
        : isParticular
        ? 280
        : isTextColumn
        ? 180
        : 120,
      maxWidth: isParticular ? undefined : (isDateColumn ? 140 : isTextColumn ? 280 : undefined),
      align: align,

      editable: activeCat === "disclosure",
      type: isDateColumn ? "text" : (align === "right" || lowerCol.includes("currentyear") || lowerCol.includes("previousyear") ? "number" : "text"),
    };
  }),
];



        return (
          <React.Fragment key={sg?._id || `table-${idx}`}>
            <ConsolFSTable
              columns={tableCols}
              rows={tableItems}
              onRowsChange={(updated, tId, from, to) => handleRowsChange(updated, sg._id, from, to)}
              onCellChangeImmediate={activeCat === "disclosure" ? undefined : handleTableEditDebounced}
              redirectTo={redirectTo}
              tableTitle= {sg?.tableTitle}
              cellFormulas={sg?.cellFormulas}
              isNotesTable={
                activeCat === "BS notes" ||
                activeCat === "PL notes" ||
                activeCat === "disclosure" ||
                activeCat === "general notes"
              }
              tableId={sg?._id}
              tableType={sg?.tableType}
              deletePopulateFS={deletePopulateFS}
              allowDragAndAdd={activeCat === "cashflow" || activeCat === "socie" || activeCat === "disclosure"}
              activeCat={activeCat}
              onAddRow={activeCat === "cashflow" ? handleCashflowRowAdd : null}
              onCellLinkClick={handleCellLinkClick}
            />
          </React.Fragment>
        );
      }

      //  TEXT 
      if (type === "text") {
        return (
          <div className="mt-2" key={sg?._id || `text-${idx}`}>
            <QuillReactEditor
              value={sg?.textRaw ?? ""}
              onChange={(content) => {
                handleDisclosureTextEditDebounced(sg?._id, content);
              }}
              onBlur={() => {
                handleDisclosureTextSave(sg?._id);
              }}
              rightControl={
                <div
                  style={{ cursor: "pointer", marginRight: 8, display: "flex", alignItems: "center" }}
                  onClick={() => {
                    setDeleteEditorConfirm({
                      isOpen: true,
                      subgroupId: sg._id,
                    });
                  }}
                  title="Delete text editor"
                >
                  <DelIcon style={{ width: 16, height: 16 }} />
                </div>
              }
            />
          </div>
        );
      }

      //  FALLBACK 
      return <div key={sg?._id || `empty-${idx}`} />;
    });
  };

  const transformData = (data) => {
    const output = [];

    const walk = (node) => {
      const type = node.lineType === "formula" ? "formula" : (node.level === 1 ? "header" : "row");

      output.push({
        _id: node._id,
        lineType: type,
        particular: node.name,
        notes: node.notes ?? null,
        currentYear: node.currentYear ?? null,
        previousYear: node.previousYear ?? null,
        references: node.references ?? [],
        isBold: node.isBold ?? false,
        level: node.level
      });

      if (node.subgroup && node.subgroup.length) {
        node.subgroup.forEach(walk);
      }
    };

    data.forEach(walk);
    return output;
  };

  return (
    <>
      <div className={`${workSpaceCss.df}`}>
        <div className={`d-flex ${commoncss.pageContent}`} style={{ overflow: "hidden" }}>
          <motion.div
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 100, opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
          >
            <PopulateFSSideMenu
              title="Consol Financial Statements"
              titleClassName={sidemenucss.customTitle}
              subTitle={subTitle}
              menuItems={menuItems}
              subMenu={subMenu}
              activeCat={activeCat}
              setActiveCat={setActiveCat}
              setSubMenuId={setSubMenuId}
              showNotesDetails={showNotesDetails}
              redirectNote={redirectNote}
              setRedirectNote={setRedirectNote}
              subMenuId={subMenuId}
              subgroupId={subgroupId}
              setSubGroupId={setSubGroupId}
              isLoading={isLoading}
              resizable={true}
              onDeleteSubGroup={handleDeleteSubGroup}
              onAddSubGroup={handleAddSubGroup}
              onEditSubGroup={handleEditSubGroup}
              onReorderSubGroup={handleReorderSubGroup}
              showCashflowWorkings={showCashflowWorkings}
              setShowCashflowWorkings={setShowCashflowWorkings}
            />
      
      <SidePanel
        showLinkPanel={showLinkPanel}
        setShowLinkPanel={setShowLinkPanel}
        activeCellKey={activeCellKey}
        selectedCell={selectedCell}
        type={activeCat === "disclosure" ? "disclosure" : activeCat === "socie" ? "socie" : activeCat}
        groupingTemplateID={workspaceID}
        dataID={panelDataID}
        disclosureID={subMenuId || fsNotesResponseData?.[0]?._id}
        isTemplate={false}
        isConsol={true}
        consolID={consolID}
        onApply={async (body, freshData) => {
          await getPopulateFS(activeCat);
        }}
      />

    </motion.div>
          <div
            className={bookclosurecss.bookClosureContent}
            style={{
                width: "85vw",
                backgroundColor: "transparent"
              }}
          >
            <div className={`${bookclosurecss.bookClosureHeader} p-0`}>
              <PopulateFSTopBar
                history={history}
                consolID={consolID}
                workspaceName={workspaceName}
                consolName={consolName}
                activeCat={activeCat}
                workspaceID={workspaceID}
                showCashflowWorkings={showCashflowWorkings}
                onToggleCashflowWorkings={() => setShowCashflowWorkings((prev) => !prev)}
                showAdjustmentLog={showAdjustmentLog}
                onOpenAdjustmentLog={() => setShowAdjustmentLog(true)}
                onBackFromAdjustmentLog={() => {
                   setShowAdjustmentLog(false);
                   setShowAddAdjustment(false);
                }}
                showAddAdjustment={showAddAdjustment}
                onAddAdjustment={() => {
                  setShowAdjustmentLog(true);
                  setShowAddAdjustment(true);
                }}
              />
            </div>
             <div
              className={`${bookclosurecss.hideScrollbar} ${bookclosurecss.tableLoadingWrapper}`}
              style={{
                height: "calc(100vh - 75px)",
                overflowX: activeCat === "socie" ? "auto" : "hidden",
                overflowY: "auto",
                padding:
                (activeCat === "cashflow" && showCashflowWorkings)
                  ? "0px 0px 0px 5px"
                  : "0px 10px 40px 20px",
              }}
            >
              {isLoading && (
                <div className={bookclosurecss.tableLoaderOverlay}>
                  <div className={bookclosurecss.tableLoaderDiv}>
                    <Spinner animation="grow" size="sm" />
                    <Spinner animation="grow" style={{ margin: "1rem" }} />
                    <Spinner animation="grow" size="sm" />
                  </div>
                </div>
              )}
              {activeCat === "cashflow" && showCashflowWorkings ? (
                <>
                  {showAdjustmentLog ? (
                      showAddAdjustment ? (
                        <AddNewAdjustment
                        projectID={consolID}
                        isConsol={true}
                        onBack={() => {
                          setShowAddAdjustment(false);
                          setShowAdjustmentLog(false);
                        }}/>
                      ) : (
                        <AdjustmentLog onAdd={() => setShowAddAdjustment(true)} />
                      )
                    ) : (
                         <CashflowWorkings
                            groupingTemplateID={consolID}
                            cashflowWorkingsID={subMenuId}
                            dataID={subMenuId}
                            autoSave={true}
                            isStandalone={true}
                            isConsol={true}
                          />
                    )}
                </>
              ) : (
                <>
                  {!isNotes && activeCat !== "checklist" && <ShowDetails />}

                  {isNotes && notesData && activeCat !== "checklist" && (
                    <>
                      {renderSubGroups(notesData)}
                    </>
                  )}

                  {/* Loader: subMenuId is set but note content not yet loaded */}
                  {isNotes && subMenuId && !notesData && !isLoading && activeCat !== "checklist" && (
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "200px", color: "#66827a" }}>
                      <Spinner animation="grow" size="sm" />&nbsp;&nbsp;
                      <Spinner animation="grow" style={{ margin: "0 8px" }} />&nbsp;&nbsp;
                      <Spinner animation="grow" size="sm" />
                    </div>
                  )}

                  {/* No note selected placeholder */}
                  {isNotes && !subMenuId && !isLoading && activeCat !== "checklist" && (
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "200px", color: "#aab8b5", fontSize: 14 }}>
                      Select a note from the left panel to view details
                    </div>
                  )}

                  {isNotes && subMenuId && activeCat === "checklist" && (
                    <ShowChecklist subMenuId={subMenuId} />
                  )}
                </>
              )}

              {showBottomAddControls && (
                <ConsolFSBottomAddSection
                  bottomBlocks={bottomBlocks}
                  onDragEndItems={onDragEndItems}
                  updateEditorContent={updateEditorContent}
                  removeItem={removeItem}
                  forceOpenTableId={forceOpenTableId}
                  setForceOpenTableId={setForceOpenTableId}
                  updateTableItem={updateTableItem}
                  handleAddParagraph={handleAddParagraph}
                  handleAddTable={handleAddTable}
                  isAddingTable={isAddingTable}
                  setIsAddingTable={setIsAddingTable}
                  onNewTableBlock={onNewTableBlock}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <DeletePopup
        isOpen={deleteEditorConfirm.isOpen}
        title="Confirm Deletion"
        message="Once deleted, you will not be able to recover this text block!"
        onConfirm={async () => {
          const idToDelete = deleteEditorConfirm.subgroupId;
          setDeleteEditorConfirm({ isOpen: false, subgroupId: null });
          if (idToDelete) {
            await deletePopulateFS(idToDelete);
          }
        }}
        onCancel={() => setDeleteEditorConfirm({ isOpen: false, subgroupId: null })}
      />
    </>
  );
};

export default ConsolFS;
       